module.exports = __webpack_public_path__ + "static/c_3-084b8be7ffe2036fb2d1892561e66489.jpg";